import { MenuItem, SvgIcon, Typography } from '@mui/material';
import { Pencil as EditIcon } from '@opengov/react-capital-assets';
import React from 'react';

import { useContextSwitcherDialogController } from '../../ContextState/useContextSwitcherDialogController';
import { useMobileKeyboardNavContext } from '../../MobileNavBar/Context/MobileKeyboardNavContext';
import { DATA_TEST } from '../../enums';
import { IEntityDetails } from '../../types';

interface IMobileEntitySwitcherProps {
  activeEntity: IEntityDetails;
  entitledEntities?: IEntityDetails[];
}

export const MobileEntitySwitcher: React.FC<IMobileEntitySwitcherProps> = ({ activeEntity, entitledEntities }) => {
  const inactiveEntities = entitledEntities?.filter((entity) => entity.id !== activeEntity.id);
  const multipleEntities = inactiveEntities?.length > 0;

  const { setSelectedEntity, setShowEntitySelectionDialog } = useContextSwitcherDialogController();
  const { firstMobileMenuItemRef } = useMobileKeyboardNavContext();

  return (
    <MenuItem
      ref={multipleEntities ? firstMobileMenuItemRef : null}
      autoFocus={multipleEntities}
      data-test={DATA_TEST.mobile_entity_switcher_menu_item}
      disableTouchRipple={true}
      sx={{
        display: 'flex',
        alignItems: 'center',
        pointerEvents: multipleEntities ? 'auto' : 'none',
        justifyContent: 'space-between',
        backgroundColor: 'action.hover',
        color: 'text.secondary',
        px: 2,
        borderTop: '1px solid',
        borderTopColor: 'divider',
        borderBottom: '1px solid',
        borderBottomColor: 'divider',
        py: 1,
        '.MuiMenuItem-root:hover': {
          backgroundColor: (theme: any) => `${theme.palette.action.hover} !important`
        },
        ':hover': {
          backgroundColor: 'action.hover',
          cursor: multipleEntities ? 'pointer' : 'default'
        },
        ':active': {
          backgroundColor: undefined
        }
      }}
      onClick={() => {
        if (multipleEntities) {
          setShowEntitySelectionDialog(true);
          setSelectedEntity(null);
        }
      }}
    >
      <Typography component="span" variant="h5">
        {activeEntity.displayName || activeEntity.name}
      </Typography>
      {multipleEntities && (
        <SvgIcon
          inheritViewBox
          component={EditIcon}
          sx={{ fontSize: '1rem' }}
          data-test={DATA_TEST.mobile_entity_switcher_icon}
        />
      )}
    </MenuItem>
  );
};
